import { EventEmitterStatic } from "base/EventEmitter";

class GlobalEvents extends EventEmitterStatic {

    static _init() {
        return super._init.apply(this, arguments);
    }

    static on(event, fn) {
        return super.on.apply(this, arguments);
    }

    static off(event, fn) {
        return super.off.apply(this, arguments);

    }

    static emit(event, data) {
        return super.emit.apply(this, arguments);

    }

    static destroy() {
        super.destroy.apply(this, arguments);
    }

    static pipe(emitter) {
        super.pipe.apply(this, arguments);
    }
}

export default GlobalEvents;
